export const query_workspace_searchItem = `
query searchItem($ownerId:String!,$itemId:String!,$userId:String!){
    searchItem(
        ownerId: $ownerId
        itemId: $itemId
        userId: $userId
    ) {
    content {
        id
        classifier
        privateRegistryId
        ownerId
        baseCurrency
        status
        revision
        personalData {
            id
            taxIdentifier
            vatIdentifier
            businessName
            name
            surname
            countryCode
            birthDate
            birthplace
            gender
            status
            }
        }
        totalElements
        totalPages
        last
        first
        empty
    }
}`;
export const query_workspace_getItem = `
query GetItem($workspaceId: String!, $userId: String!) {
    getItem(workspaceId: $workspaceId, userId: $userId) {
        empty
        personalData {
            id
            taxIdentifier
            vatIdentifier
            businessName
            name
            surname
            countryCode
            birthDate
            birthplace
            gender
            status
        }
        offices {
            id
            description
            officeType
            streetNumber
            streetName
            province
            city
            district
            zipCode
            region
            country
            status
        }
        accounting
        generalConfiguration
        ownerId
        baseCurrency
        revision
        itemId
        deleted
        antiMoneyLaundering {
            id
            verifiedBy
            verifiedWith
            other
            politicallyExposedPerson
            politicalOfficeHeld
            occupationalActivity
        }
        classifier
        privateRegistryId
        id
        taxation
        intermediaryId
        status
    }
}`;
